import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { ImportDataMutation } from "src/api/Organization";
import BackButton from "src/components/buttons/BackButton";
import { BorderButton } from "src/components/buttons/BorderButton";
import { InputUpload } from "src/components/inputs/InputUpload";
import Container from "src/components/layout/Container";
import Section from "src/components/layout/Section";
import { apiClient } from "src/stores/Api";
import helmet from "src/utils/helmet";
import message from "src/utils/message";

interface Props {}

export default function ImportSwimAmerica(props: Props) {
  const match = useParams<{ id: string }>();

  useEffect(() => {
    helmet.setPageTitle("Import Swim America");
  }, []);

  async function handleFileChange(file) {
    const processingMessage = message.loading("Processing…");

    try {
      const result = await apiClient(ImportDataMutation, {
        variables: {
          data: {
            fileId: file.id,
            organizationId: match.id,
            type: "swimAmerica",
          },
        },
      });

      processingMessage();
      message.success(result.importData.messages.join(", "));

      console.log("result", result);
    } catch (e) {
      processingMessage();
      console.error(e);
      message.error("Error importing Swim America data");
    }
  }

  return (
    <Section>
      <Container>
        <BackButton />
        <h1>Import Swim America Organizations</h1>
        <div className="flex gap-4">
          <div className="flex-1">
            <InputUpload onChange={handleFileChange} accept=".csv">
              <BorderButton>Upload File</BorderButton>
            </InputUpload>
          </div>
        </div>
      </Container>
    </Section>
  );
}
